module.exports = __webpack_public_path__ + "static/media/wizards-orange.0fdf1697.svg";